import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';

import { useMessageEvent } from '@post-office/message-lifecycle';
import { FormattedMessage } from 'react-intl';

import { PlacementFrontend } from '@post-office/browser--growth/confluence-side-nav';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ handleOnDismissed }: { handleOnDismissed: () => void }) => {
			const { onClosed } = usePostOfficeUserInteractions();
			const { messageDismissed } = useMessageEvent();

			const onDismissed = (): void => {
				void onClosed({
					interactionIdentifier: 'confluence-side-nav-create-a-space-dismiss',
				});
				void messageDismissed();
				handleOnDismissed();
			};

			return (
				<button onClick={onDismissed}>
					<FormattedMessage
						id="post-office.confluence-side-nav-create-a-space.dismiss"
						defaultMessage="Dismiss"
						description="Dismiss the create a space message in the Confluence side navigation"
					/>
				</button>
			);
		},
	},
});
